export enum TypeOfDialog {
	COMMENT_DIALOG = 'COMMENT_DIALOG',
	FILE_REPORT_DIALOG = 'File Report',
	LINK_DIALOG = 'LINK_DIALOG',
}
